import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { setToken } from "../lib/api";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState({ status: "verifying", msg: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", msg: "Missing token" }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-link/verify", { token });
        setToken(data.token);
        setState({ status: "success", msg: "Welcome" });
        const dest = data.user?.role === "admin" ? "/admin" : "/portal";
        setTimeout(() => nav(dest), 600);
      } catch (e) {
        setState({ status: "error", msg: e?.response?.data?.detail || "Invalid or expired link" });
      }
    })();
    // Single-shot token verification on mount/query change. `api` + `setToken`
    // are stable module singletons; including them would not change behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, nav]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="text-center" data-testid="auth-callback">
        {state.status === "verifying" && <><Loader2 className="animate-spin mx-auto text-brand-primary" size={40}/><p className="mt-4 text-slate-700">Verifying your link…</p></>}
        {state.status === "success" && <><CheckCircle2 className="mx-auto text-emerald-500" size={48}/><p className="mt-4 text-slate-900 text-lg">Signed in — redirecting…</p></>}
        {state.status === "error" && <>
          <XCircle className="mx-auto text-rose-500" size={48}/>
          <p className="mt-4 text-slate-900">{state.msg}</p>
          <button onClick={() => nav("/login")} className="mt-6 px-5 py-2 rounded-md font-semibold" style={{ background: "#0F1644", color: "#fff" }} data-testid="back-to-login-btn">Back to sign in</button>
        </>}
      </div>
    </div>
  );
}
